const show = function (options) {
  if(!options || typeof options !== 'object') {
    throw new Error("Expected Dialog's options be an object!")
  }

  // 将组件的props默认值放入defaluts对象中
  const defaults = {}
  Object.entries(this.$props).forEach(([key, value]) => {
    if(typeof value !== 'undefined') {
      defaults[key] = value
    }
  })
  // 将组件的props默认值和自定义传入的options配置合并，自定义配置会覆盖默认值
  const combinedOptions = {...defaults, ...options}
  Object.entries(combinedOptions).forEach(([key, value]) => {
    this[key] = value // 将合并后的props重新赋值给组件实例
  })

  // 如果自定义配置中传入了onShow勾子函数，立即执行
  options.onShow && options.onShow()

  // 如果$watcher监听器已经存在，取消它
  // 然后添加一个新的$watcher监听器，监听组件实例的show字段，目的是为了在隐藏组件时触发onHide勾子函数
  this.$watcher && this.$watcher()
  this.$watcher = this.$watch('show', val => {
    !val && options.onHide && options.onHide()
  })

  // 同上，如果已经存在on-cancel和on-confirm事件监听器，先卸载然后重新监听，用来触发onCancel或onConfirm勾子函数
  // 这块代码只在Confrim和Prompt中有用，其他组件中不起效但也不影响
  this.$off(['on-cancel', 'on-confirm'])
  this.$on('on-cancel', () => {
    options.onCancel && options.onCancel()
  })
  this.$on('on-confirm', val => {
    options.onConfirm && options.onConfirm(val)
  })

  this.show = true
}

const hide = function () {
  this.show = false
}

const install = (pluginKey, component) => {
  return (Vue, options = {}) => {
    const Component = Vue.extend(component)
    const $vm = new Component({
      el: document.createElement('div'),
      propsData: {
        ...options,
      },
    })
    document.body.appendChild($vm.$el)

    const plugin = {
      show: show.bind($vm),
      hide: hide.bind($vm),
    }

    if(!Vue.prototype[pluginKey]) {
      Vue.prototype[pluginKey] = plugin
    }
  }
}

export {install}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/plugins/util.js